var e = require("parse-unit"),
    r = function (r) {
  return e(r)[0];
};

module.exports = function (n) {
  return null == n && (n = n), function (u, i, t, f) {
    null == t && (t = n), null == f && (f = t);

    var l = function (r) {
      return e(r)[1];
    }(u);

    if (l === i) return u;
    var o = r(u);
    if ("px" !== l) if ("em" === l) o = r(u) * r(t);else if ("rem" === l) o = r(u) * r(n);else {
      if ("ex" !== l) return u;
      o = r(u) * r(t) * 2;
    }
    var a = o;
    if ("px" !== i) if ("em" === i) a = o / r(f);else if ("rem" === i) a = o / r(n);else {
      if ("ex" !== i) return u;
      a = o / r(f) / 2;
    }
    return parseFloat(a.toFixed(5)) + i;
  };
};